import { render, staticRenderFns } from "./SolturaDeFrotaPrincipal.vue?vue&type=template&id=67b10484&"
import script from "./SolturaDeFrotaPrincipal.vue?vue&type=script&lang=js&"
export * from "./SolturaDeFrotaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports